<script setup lang="ts">
import VueTimepicker from 'vue3-timepicker';
import 'vue3-timepicker/dist/VueTimepicker.css';

defineProps<{
  modelValue: any;
  label?: string;
  placeholder?: string;
}>();

const emit = defineEmits<{
  (event: 'update:modelValue', payload: any): void;
}>();

function updateValue(value: any) {
  emit('update:modelValue', value);
}
</script>

<template>
  <div class="time-picker">
    <span class="__label">{{ label }}</span
    ><VueTimepicker
      @change="updateValue"
      :model-value="modelValue"
      format="hh:mm a"
      :placeholder="placeholder"
    />
    <slot></slot>
  </div>
</template>

<style scoped>
.time-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}

.vue__time-picker {
  width: 80%;
  margin-left: 16px;
}

.__label {
  font-weight: 500;
  font-size: 16px;
  color: var(--co-text-secondary);
  width: 30%;
}
</style>

<style>
.time-picker .vue__time-picker input.vue__time-picker-input {
  width: 100%;
  border-radius: 8px;
  height: 44px;
  padding: 13px 12px;
  font-size: 16px;
  outline: none;
}

.time-picker .vue__time-picker input.vue__time-picker-input:focus {
  border: 1px solid var(--co-text-highlight);
}

.time-picker:focus-within > .__label {
  color: var(--co-text-highlight);
}

.time-picker .vue__time-picker .controls {
  right: 12px;
}

.time-picker .vue__time-picker .dropdown {
  top: 50px;
  border-radius: 8px;
  font-size: 16px;
}

.time-picker .vue__time-picker .dropdown,
.time-picker .vue__time-picker .dropdown .select-list {
  width: 100%;
}

.time-picker .vue__time-picker .dropdown ul li:not([disabled]).active,
.time-picker .vue__time-picker .dropdown ul li:not([disabled]).active:focus,
.time-picker .vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: var(--co-background-secondary);
  color: var(--co-text-highlight);
  font-weight: bold;
}

.time-picker .vue__time-picker .dropdown ul li:not(.hint):not([disabled]):focus,
.time-picker
  .vue__time-picker
  .dropdown
  ul
  li:not(.hint):not([disabled]):hover {
  background: var(--co-background-secondary);
}

.time-picker .vue__time-picker .dropdown ul {
  padding: 10px 0;
}
</style>
